import axios, { AxiosError, AxiosResponse } from 'axios';
import { Token } from '@atabix/core';
import { trim } from '@/support/String';
import ErrorHandler from './ErrorHandler';
import { Config } from '@/core';


let API = '';
const Qs = require('qs');

export default (method: string, url: string, payload: object, version: boolean = true) => {
  let headers = {
    Accept: 'application/json',
    'Content-type': 'application/json',
  };

  API = version ? `${identifyHostname()}${Config.get('VUE_APP_API_VERSION')}` : `${identifyHostname()}`;

  if (isLocal()) {
    (headers as any)['X-Application'] = identifyApplication();
  }

  if (Token.get('access')) {
    (headers as any).Authorization = `Bearer ${Token.get('access')}`;
  }

  if(Token.get('lead')) {
    (headers as any)['X-Lead-Token'] = `${Token.get('lead')}`;
  }

  const client = axios.create({
    baseURL: API,
    headers,
    paramsSerializer: (params: any) => {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });

  let hasFile = false;
  const keys = Object.keys(payload);

  if (!payload) {
    payload = {};
  }

  keys.forEach((property, index) => {
    if ((payload as any)[property] !== undefined && (payload as any)[property] !== null && (payload as any)[property].name !== undefined && (payload as any)[property].lastModified !== undefined && (payload as any)[property].size !== undefined) {
      hasFile = true;
    }
  });

  if (hasFile) {
    // const formData = new FormData();
    // keys.forEach((property, index) => {
    //   formData.append(property, (payload as any)[property]);
    // });
    payload = objectToFormdata(payload);
  }

  if (method.toLowerCase() === 'get') {
    payload = {
      params: payload,
    };
  }
  if (method.toLowerCase() === 'delete') {
    payload = {
      data: payload,
    };
  }


  return (client as any)
    [method](url, payload)
    .then((response: AxiosResponse) => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const isLocal = (): boolean => {
  if (! Config.get('VUE_APP_API_LOCAL') || Config.get('VUE_APP_API_LOCAL') === 'false') {
    return false;
  }

  const port = window.location.port;

  return ! port || port != '80';
};

export const isHttps = (): boolean => {
  return Config.get('VUE_APP_API_HTTPS') && Config.get('VUE_APP_API_HTTPS') === 'false' ? false : true;
};

export const identifyApplication = (): string => {
  const host = window.location.host;
  const application = host.split('.')[0];

  if (application.includes('localhost:') || host.includes(':8080')) {
    if (Config.get('VUE_APP_TENANT')) {
      return `${Config.get('VUE_APP_TENANT')}`;
    }
    return '';
  }

  return application;
};

export const identifyHostname = (): string => {
  const hostName = trim('.', Config.get('VUE_APP_API') as string);
  const hostProtocol = isHttps() ? 'https' : 'http';

  return `${hostProtocol}://${hostName}`;
};

export const objectToFormdata = (payload: any, form: any = null, namespace: any = null): FormData => {
  const fd: FormData = form || new FormData();
  let formKey: string | null = null;

  Object.keys(payload).forEach((key: string) => {
    if (namespace) {
      formKey = `${namespace}[${key}]`;
    } else {
      formKey = key;
    }
    if (typeof payload[key] === 'object' && !(payload[key] instanceof File)) {
      objectToFormdata(payload[key], fd, key);
    } else {
      fd.append(formKey, payload[key]);
    }
  });
  return fd;
};

export const axiosDownload = async (options: AxiosDownloadOptions, payload?: object): Promise<void> => {
  const API = `${identifyHostname()}`;

  const headers: {[key: string]: string | null} = {
    'Content-type': 'application/json',
  };

  headers.Accept = options.accept || 'application/vnd.ms-excel';

  if (Token.get('access')) {
    (headers as any).Authorization = `Bearer ${Token.get('access')}`;
  }

  const client = axios.create({
    baseURL: API,
    headers,
    responseType: 'blob',
  });

  await client
    .get(options.url, payload ? { params: payload } : {})
    .then((response: AxiosResponse) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', getContentDispositionName(response));
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.remove();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
};

const getContentDispositionName = (response: AxiosResponse) => {
  const disposition = response.request.getResponseHeader('Content-Disposition');
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(disposition);
  let name = '';
  if (matches != null && matches[1]) {
    name = matches[1].replace(/['"]/g, '');
  }

  return name;
}

export interface AxiosDownloadOptions {
  url: string;
  accept?: string;
}
